'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
const useFileUploadInstructions = translations => {
  const $ = _c(4);
  const uploadTypeId = _temp;
  const uploadId = _temp2;
  let t0;
  if ($[0] !== translations) {
    t0 = (selectedType_0, isDropActive, blocked_1) => [uploadId(isDropActive, blocked_1), uploadTypeId(selectedType_0, blocked_1)].filter(_temp3).map(id_0 => translations.formatMessage({
      id: id_0
    })).join(" ");
    $[0] = translations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const uploadInstructions = t0;
  let t1;
  if ($[2] !== uploadInstructions) {
    t1 = {
      uploadInstructions
    };
    $[2] = uploadInstructions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default useFileUploadInstructions;
function _temp(selectedType, blocked) {
  if (blocked) {
    return "";
  }
  if (!selectedType.handle) {
    return "";
  }
  return [selectedType.handle, "INSTRUCTIONS"].join(".");
}
function _temp2(isDragActive, blocked_0) {
  if (blocked_0) {
    return "UPLOADING";
  }
  if (isDragActive) {
    return "UPLOADING.DRAG_DROP";
  }
  return "UPLOADING.DRAG_DROP_CLICK";
}
function _temp3(id) {
  return !!id;
}